export default __webpack_public_path__ + "static/media/include_14_female@2x.f1fb877f.jpg";